export default {
    required : [
        {
            value : "reportingYear",
            label : "Reporting Year"
        },
        {
            value : "reportingEntityIdFk",
            label : "Reporting Entity"
        },
        {
            value : "reportingUnitIdFk",
            label : "Reporting Unit"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/constants/ReportColumns.js